module.exports = __webpack_public_path__ + "img/vrbox-bg.f0b0cd49.jpg";